module.exports = __webpack_public_path__ + "static/media/11221.555f9745.jpg";